'use strict'

export default {
  en: require('./en'),
  th: require('./th')
}
